import React, { useEffect, useRef, useState } from 'react';

const AnimatedCounter = ({ value, duration = 2000, className }) => {
  const [display, setDisplay] = useState('0');
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const match = String(value).match(/^([\d,\.]+)(.*)$/);
    if (!match) {
      setDisplay(String(value));
      return;
    }

    const rawNum = match[1].replace(/,/g, '');
    const suffix = match[2];
    const hasDecimal = rawNum.includes('.');
    const decimals = hasDecimal ? rawNum.split('.')[1].length : 0;
    const target = parseFloat(rawNum);
    const formatter = new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !started.current) {
          started.current = true;
          const startTime = performance.now();
          const tick = (now) => {
            const progress = Math.min((now - startTime) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            setDisplay(formatter.format(target * eased) + suffix);
            if (progress < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        }
      },
      { threshold: 0.6 }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [value, duration]);

  return (
    <span ref={ref} className={className}>
      {display}
    </span>
  );
};

export default AnimatedCounter;
